import Select from "react-select"
import { useStoresSWR } from "src/hooks/useStoresSWR"

type Option = { value: string; label: string }

type Props = {
  /** FormField が label と結び付けるために渡す id */
  id?: string
  value: string
  onChange: (value: string) => void
  error?: boolean
}

/** 受電ログに紐付ける店舗を、店舗名・ID で検索して選ぶ。未選択は空文字 */
export const IncomingCallLogStoreSelect: React.FC<Props> = ({ id, value, onChange, error }) => {
  const { storesSwr } = useStoresSWR()

  const options: Option[] = (storesSwr.data?.stores ?? []).map((store) => ({
    value: store.id.toString(),
    label: `${store.name}（ID: ${store.id}）`,
  }))
  const selectedOption = options.find((option) => option.value === value) ?? null

  return (
    <Select<Option>
      inputId={id}
      options={options}
      value={selectedOption}
      onChange={(option) => onChange(option?.value ?? "")}
      isClearable
      isLoading={storesSwr.isLoading}
      placeholder="店舗名・ID で検索"
      noOptionsMessage={() => "該当する店舗はありません"}
      loadingMessage={() => "店舗を読み込んでいます…"}
      // モーダルは overflow で中身を切り取るので、選択肢は body に出す
      menuPortalTarget={typeof document === "undefined" ? null : document.body}
      styles={{
        control: (styles) => ({
          ...styles,
          minHeight: 40,
          borderColor: error ? "var(--color-text-error)" : styles.borderColor,
        }),
        menuPortal: (styles) => ({ ...styles, zIndex: 60 }),
      }}
    />
  )
}
